import React from 'react';
import { Content, Box } from 'reactjs-admin-lte';
import Pagination from 'components/core/Pagination';
import UnsupportedOrderListTable from './UnsupportedOrderListTable';

const UnsupportedOrderList = (props) => {
  const {
    orders,
    isLoading,
    handleTabOpen,
    currentPage,
    pageSize,
    handlePageSelect,
  } = props;
  
  return (
    <Content.Body>
      <Box
        className="box-widget mb-0"
        loading={isLoading}>
        <Box.Body
          noPadding={true}>
          <UnsupportedOrderListTable
            orders={orders}
            handleTabOpen={handleTabOpen} />
        </Box.Body>
        <Box.Footer>
          <Pagination
            currentPage={currentPage}
            totalPages={pageSize}
            onChange={handlePageSelect} />
        </Box.Footer>
      </Box>
    </Content.Body>
  );
}

export default UnsupportedOrderList;
